<template>
  <div>
    <v-data-table :headers='headers' :items='items' class='elevation-1'>
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Gestión de Docente</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn color='primary' @click='openDialog'>Agregar</v-btn>
        </v-toolbar>
      </template>
      <template v-slot:headers>{{ tableHeaders }}</template>
      <template v-slot:items='{ item }'>
          <td>{{ item.DocenteId }}</td>
          <td>{{ item.Dni }}</td>
          <td>{{ item.ApellidoNombre }}</td>
          <td>{{ item.Email }}</td>
        </template>
        <template v-slot:item.Acciones="{ item }">
        <td>
          <v-btn icon @click='editItem(item)'><v-icon>mdi-pencil</v-icon></v-btn>
          <!-- <v-btn icon @click='deleteItem(item)'><v-icon>mdi-delete</v-icon></v-btn> -->
        </td>
        </template>
    </v-data-table>

    <v-dialog v-model='dialog'>
      <v-card>
        <v-card-title>
          <span class='headline'>{{ form.id ? 'Editar' : 'Agregar' }} Docente</span>
        </v-card-title>
        
        <v-card-text>
          <v-container>
            <v-form ref="form" v-model="valid">
              <v-text-field label='Dni' v-model='form.dni' :rules='[rules.required]' required></v-text-field>
              <v-text-field label='Apellido, Nombre' v-model='form.apellidoNombre' :rules='[rules.required]' required></v-text-field>
              <v-text-field label="Email" v-model="form.email" :rules="[rules.required, rules.email]" required></v-text-field>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color='primary' @click='saveItem' :disabled="!valid" :loading="loading">Guardar</v-btn>
          <v-btn color='grey' @click='closeDialog'>Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import DocenteSrv from "../../services/Docente.service"
export default {
  data() {
    return {
      headers: [
        { text: 'DocenteId', value: 'docenteId' },
        { text: 'Dni', value: 'dni' },
        { text: 'ApellidoNombre', value: 'apellidoNombre' },
        { text: 'Email', value: 'email' },
        { text: 'Acciones' ,value: 'Acciones'}
      ],
      items: [],
      dialog: false,
      valid: false,
      loading: false,
      form: {},
      rules: {
        required: value => !!value || 'Este campo es obligatorio',
        email: value => /.+@.+\..+/.test(value) || 'Debes ingresar un correo electrónico válido.'
      }
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.dialog = false;
      this.loading = false;
      this.valid = false;
      DocenteSrv.ObtenerTodo().then((result) => {
        this.items=result.data;
      }).catch((err) => {
        
      });
    },
    openDialog() {
      this.form = {};
      this.dialog = true;
    },
    closeDialog() {
      this.dialog = false;
      this.valid = false;
      this.form = {};
    },
    editItem(item) {
      this.form = { ...item };
      this.dialog = true;
    },
    saveItem() {
      this.loading = true;
      this.$refs.form.validate();
      if (!this.valid) return;
      // Axios POST o PUT aquí
      if(!this.form.docenteId){
        DocenteSrv.Insertar(this.form).then((result) => {
          this.$toast.success(result.data);
          this.fetchData();
        }).catch((err) => {
          this.$toast.error(err.data);
          this.dialog = false;
          this.loading = false;
        });
      }else{
        DocenteSrv.Editar(this.form).then((result) => {
          this.$toast.success(result.data);
          this.fetchData();
        }).catch((err) => {
          this.$toast.error(err.data);
          this.dialog = false;
          this.loading = false;
        });
      }
    },
    deleteItem(item) {
      // Axios DELETE aquí
    }
  }
};
</script>